import React from 'react';
import { useIntl } from 'react-intl';
import { Input } from 'shared-components';
import PropTypes from 'prop-types';
import { profileEn } from '../../../../i18n/profile';
import Title from '../../../../components/Title';
import CraDdaStatusBadge from '../../../../components/CraDdaStatusBadge';
// Import Global Layouts
import Form from '../../../../layouts/Form';
import InputGroup from '../../../../layouts/InputGroup';
import InputRow from '../../../../layouts/InputRow';
import { TitleWrapper } from '../Form/styles';

const DirectDepositAccountInfo = ({
  accountInfo: { bank_details: bankDetails, id: accountId },
  onEnroll,
}) => {
  const intl = useIntl();
  const page = 'profile';

  const renderUSFields = () => (
    <InputRow>
      <InputGroup
        label={intl.messages['profile-account-info-routing-number-label']}
        labelFor="routingNumber"
        page={page}
      >
        <Input
          value={bankDetails.routing_number || '--'}
          id="profile-routingNumber"
          disabled="disabled"
        />
      </InputGroup>
      <InputGroup
        label={intl.messages['profile-account-info-account-number-label']}
        labelFor="accountNumber"
        page={page}
      >
        <Input
          value={bankDetails.account_number || '--'}
          id="profile-accountNumber"
          disabled="disabled"
        />
      </InputGroup>
    </InputRow>
  );

  const renderCanadaFields = () => (
    <InputRow>
      <InputGroup
        label={intl.messages['profile-account-info-transit-number-label']}
        labelFor="transitNumber"
        page={page}
      >
        <Input
          value={bankDetails.transit_number || '--'}
          id="profile-transitNumber"
          disabled="disabled"
        />
      </InputGroup>
      <InputGroup
        label={intl.messages['profile-account-info-institution-number-label']}
        labelFor="institutionNumber"
        page={page}
      >
        <Input
          value={bankDetails.institution_number || '--'}
          id="profile-institutionNumber"
          disabled="disabled"
        />
      </InputGroup>
      <InputGroup
        label={intl.messages['profile-account-info-account-number-label']}
        labelFor="accountNumber"
        page={page}
      >
        <Input
          value={bankDetails.account_number || '--'}
          id="profile-accountNumber"
          disabled="disabled"
        />
      </InputGroup>
    </InputRow>
  );

  return (
    <Form as="div">
      <TitleWrapper>
        <Title
          title={profileEn['profile-account-info-title']}
          titleFor='account-info'
          page={page}
        />
        {accountId && <CraDdaStatusBadge accountId={accountId} onEnroll={onEnroll} />}
      </TitleWrapper>

      {bankDetails.routing_number ? renderUSFields() : renderCanadaFields()}
    </Form>
  );
};

DirectDepositAccountInfo.propTypes = {
  accountInfo: PropTypes.shape({
    id: PropTypes.number,
    bank_details: PropTypes.shape({
      routing_number: PropTypes.string,
      transit_number: PropTypes.string,
      institution_number: PropTypes.string,
      account_number: PropTypes.string,
    }),
  }),
  onEnroll: PropTypes.func,
};

DirectDepositAccountInfo.defaultProps = {
  accountInfo: null,
  onEnroll: null
};

export default DirectDepositAccountInfo;
